import axios from "axios"
import Consts from "../app/consts"

export default class DeviceTargetingService {
  static getDeviceTargetingGroups() {
    return axios.get(Consts.BASE_API_URL + "/api/device_targeting_groups")
  }
}
